import React from 'react';
import error404 from '../../../../assets/img/Errors/404-error.png';
import './missing-page.scss';

import ErrorPage from '../../../../components/error-pages/error'

// error page for 404 errors (page does not exist)
const MissingPage = () => {
    const classname = "missing-page";
    const title = "Triyo - Missing";
    const image = <img className="missing-picture" src={error404} alt={"404 Error"} />
    const header = <h4 className="missing-title" style={{fontWeight: 'bolder'}}> Page not found </h4>
    const info = <p className="missing-info">Sorry, the page you are looking for does not exist or has been moved. <br></br> Please return to the Task page.</p>
    const buttonText = "Go to Task Page";

    return (
        <ErrorPage
            className={classname}
            image={image}
            title={title}
            header={header}
            info={info}
            buttonText={buttonText}
        />
    )
}

export default MissingPage;